import type { OptionChangedEvent } from 'devextreme/ui/data_grid';
import type DataSource from 'devextreme/data/data_source';

type GridOptionChangedEvent = Pick<OptionChangedEvent, 'name'> &
  Partial<Pick<OptionChangedEvent, 'fullName'>>;

/** True when a DevExtreme grid option change should refetch a remote CustomStore. */
export function shouldReloadRemoteGridOnOptionChanged(event: GridOptionChangedEvent): boolean {
  const { name, fullName } = event;

  if (name === 'filterValue' || name === 'filterPanel' || name === 'searchPanel') {
    return true;
  }

  if (name === 'columns' && fullName) {
    return /(?:^|[.\]])filter(?:Value|Values|Type)$|(?:^|[.\]])selectedFilterOperation$/.test(fullName);
  }

  return false;
}

export function reloadRemoteGridDataSource(dataSource: DataSource): void {
  void dataSource.reload();
}

export function createRemoteGridFilterOptionChangedHandler(dataSource: DataSource) {
  return (event: GridOptionChangedEvent) => {
    if (shouldReloadRemoteGridOnOptionChanged(event)) {
      reloadRemoteGridDataSource(dataSource);
    }
  };
}
